module.exports = __webpack_public_path__ + "img/banner-1.fa762af9.png";